import { createSlice } from "@reduxjs/toolkit";
import { leftProject } from "../actions/leftProjectAction";

const initialState = {
  loading: false,
  error: null,
  success: false,
};

const leftProjectSlice = createSlice({
  name: "leftProject",
  initialState,
  reducers: {
    resetState: (state) => {
      console.log("Resetting leftProject state");
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(leftProject.pending, (state) => {
        console.log("leftProject.pending - Setting loading state");
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(leftProject.fulfilled, (state, action) => {
        console.log("leftProject.fulfilled - Action payload:", action.payload);
        state.loading = false;
        state.error = null;
        state.success = true;
      })
      .addCase(leftProject.rejected, (state, action) => {
        console.log("leftProject.rejected - Error payload:", action.payload);
        console.log("leftProject.rejected - Full action:", action);
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const { resetState } = leftProjectSlice.actions;
export default leftProjectSlice.reducer;
